import React from 'react';
import AgencyTemplate from '../components/AgencyTemplate';

const KCI = () => {
  const agencyData = {
    title: "Kinetics Controls & Innovation Ltd (KCI)",
    subtitle: "Petrochoice Agencies",
    description: "KCI (UK Origin) is a global provider of fully engineered leak sealing solutions to re-establish well integrity, taking a holistic approach by providing in-depth investigation and assessment for every project. KCI deliver exceptional customer service and accountability via a highly skilled and experienced engineering team that includes industry specialists who are there for the project every step of the way. The innovation in KCI's business comes from employing its engineering expertise to support complex problems which may be difficult to resolve with conventional methods or technologies. KCI have been providing rigless well integrity and intervention isolations around the world since 2002.",
    image: "/assets/kci-image.png",
    imageAlt: "KCI showcase",
    features: [
      {
        title: "Leak Sealing Solutions",
        description: "Fully engineered solutions to re-establish well integrity with comprehensive investigation and assessment.",
        icon: "bi bi-shield-check",
        iconColor: "#0c61c0"
      },
      {
        title: "Rigless Well Integrity",
        description: "Providing rigless well integrity and intervention isolations around the world since 2002.",
        icon: "bi bi-tools",
        iconColor: "#28a745"
      }
    ]
  };

  return <AgencyTemplate {...agencyData} />;
};

export default KCI;



